import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionsKey } from "../data/permissions";

export interface AdminState {
  refreshToken: string;
  accessToken: string;
  permissions: PermissionsKey[];
}

const initialState: AdminState = {
  refreshToken: "",
  accessToken: "",
  permissions: [
    PermissionsKey.ViewStores,
    PermissionsKey.ViewOwners,
    PermissionsKey.ViewAvatar,
  ],
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    loginAdmin(
      state,
      action: PayloadAction<{
        refreshToken: string;
        accessToken: string;
        permissions: PermissionsKey[];
      }>
    ) {
      state.refreshToken = action.payload.refreshToken;
      state.accessToken = action.payload.accessToken;
      state.permissions = action.payload.permissions;
    },
    logoutAdmin(state) {
      state.accessToken = "";
      state.refreshToken = "";
      state.permissions = [];
    },
    refreshAdminTokens(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) {
      state.refreshToken = action.payload.refreshToken;
      state.accessToken = action.payload.accessToken;
    },
  },
});

export const { loginAdmin, logoutAdmin, refreshAdminTokens } =
  adminSlice.actions;
export default adminSlice.reducer;
